module.exports = __webpack_public_path__ + "static/assets/0d85abb7c2c37a2e37a28ad9e43382ed.png";